// prefeitura_frontend/src/pages/admin/globalActivityDashboard/styles.ts
import { styled } from '@mui/material/styles';
import { Box, Paper, Typography, Container, Card, CardContent } from '@mui/material';

export const PageContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontWeight: 'bold',
  color: '#fff',
  display: 'none', // Escondendo o título conforme solicitado
}));

export const FilterContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: 'rgba(21, 32, 43, 0.6)',
  boxShadow: 'none',
  borderRadius: '8px',
  border: '1px solid rgba(255, 255, 255, 0.05)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const CardsContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: '0 2px',
  width: '100%',
  display: 'flex',
}));

export const TableContainer = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  borderRadius: theme.shape.borderRadius,
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  minHeight: '200px',
}));

export const StatusChip = styled(Box)(({ theme, color }: { theme?: any, color: string }) => ({
  display: 'inline-block',
  padding: '3px 6px',
  borderRadius: '4px',
  fontSize: '0.65rem',
  fontWeight: 'bold',
  backgroundColor: color,
  color: '#fff',
  textAlign: 'center',
  minWidth: '60px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
}));

export const ActivityCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#15202b',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  transition: 'all 0.2s ease',
  height: '250px', // Altura fixa para todos os cards
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  borderRadius: '8px',
  overflow: 'visible', // Permite que o conteúdo não seja cortado
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)',
    borderColor: 'rgba(255, 255, 255, 0.15)',
  },
}));

export const ActivityCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(1.5),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between',
  '&:last-child': {
    paddingBottom: theme.spacing(1.5),
  },
}));

export const ActivityMetadata = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
}));

export const DueDateWarning = styled(Box)(({ theme, isOverdue }: { theme?: any, isOverdue: boolean }) => ({
  color: isOverdue ? '#e74c3c' : '#f39c12',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontWeight: isOverdue ? 'bold' : 'normal',
  marginTop: '4px',
  fontSize: '0.7rem',
}));

export const AssigneesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
  marginTop: '8px',
  paddingTop: 0,
  alignItems: 'center',
}));

export const StatsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(1),
  width: '100%',
  paddingLeft: '6px',
  paddingRight: '6px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),
  }
}));

export const StatsCard = styled(Paper)(({ theme, color }: { theme?: any, color: string }) => ({
  backgroundColor: 'rgba(21, 32, 43, 0.6)',
  border: '1px solid rgba(255, 255, 255, 0.05)',
  borderLeft: `4px solid ${color || '#3498db'}`,
  borderRadius: '8px',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: '200px',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    borderLeft: `4px solid ${color || '#3498db'}`,
  }
}));